import type { AgeBand } from '@/lib/aging'

/** Mark drawn in a grid cell's corner so the band survives without colour
 *  (UF-05). `ok` and an empty cell carry none. */
export function cellMark(worst: AgeBand | null, count: number): string {
  if (count === 0) return ''
  switch (worst) {
    case 'over':     return '!!!'
    case 'critical': return '!!'
    case 'warning':  return '!'
    default:         return ''
  }
}
